import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DialogComponent } from '@plugins/client/dialog/dialog.component';
import { DIALOG_DATA } from '@plugins/client/dialog/tokens';
import {
  AnimationDirective,
  AnimationsConfig,
  AnimationState,
} from '@plugins/client/directives/animation.directive';
import { NoticeComponent } from '@plugins/client/notice';
import { DompurifyPipe } from '@plugins/client/pipes/html/dompurify.pipe';
import { Nl2BrPipe } from '@plugins/client/pipes/html/nl2br.pipe';

import { ToastData } from './types';

@Component({
  selector: 'plugins-toast',
  imports: [NoticeComponent, Nl2BrPipe, DompurifyPipe, AnimationDirective],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  readonly data = inject(DIALOG_DATA) as ToastData;
  readonly dialogRef = inject(DialogComponent);
  showToast = true;

  readonly animations: AnimationsConfig = {
    enter: {
      type: ['fade', 'slideTop'],
      timingOptions: { duration: 250, fill: 'forwards' },
    },
  };

  onClose() {
    this.showToast = false;
  }

  onAnimationDone(state: AnimationState) {
    if (state === 'leave') {
      this.dialogRef.close();
    }
  }
}
